/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * One-click setup at the domain's DNS provider. Omitted entirely when the provider does not support
 *
 * @remarks
 * Domain Connect or discovery failed, so the object's presence is the signal that the shortcut is
 * available and both of its fields are filled.
 */
export type DomainConnect = {
  /**
   * Display name of the DNS provider the domain is delegated to, such as 'Cloudflare'. Discovered
   *
   * @remarks
   * from the domain's nameservers, so it reflects where DNS is actually hosted rather than where the
   * domain was registered.
   */
  provider: string;
  /**
   * Signed Domain Connect URL that pre-fills the records in `dnsRecords` at the provider. Open it in a
   *
   * @remarks
   * browser and the domain owner approves them in one step instead of entering them by hand. The URL is
   * signed with an Teral key, so it cannot be constructed or altered by the caller.
   *
   * Intended for a browser, not a script: after approval the provider sends the browser to this
   * workspace's app settings page in the Teral dashboard, so it suits a caller who administers this
   * workspace. Anyone who does not have access to it approves the records successfully but lands on a
   * page they cannot open. Approving is what writes the records; verification then proceeds on its own,
   * so nothing depends on completing that return trip.
   */
  url: string;
};

/** @internal */
export const DomainConnect$inboundSchema: z.ZodType<
  DomainConnect,
  z.ZodTypeDef,
  unknown
> = z.object({
  provider: z.string(),
  url: z.string(),
});

export function domainConnectFromJSON(
  jsonString: string,
): SafeParseResult<DomainConnect, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DomainConnect$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DomainConnect' from JSON`,
  );
}
